import Select from 'react-dropdown-select';
import styled from "styled-components";

const StyledSelect = styled(Select)`
    border: 1px solid #D2D5D7 !important;
    color: black;
    height: 54px;
    border-radius: 16px !important;

    .react-dropdown-select {
        border-radius: 16px;
    }
  
    .react-dropdown-select-content{
        font-size: 18px;
        font-weight: 500;
        padding: 0 30px 0 10px;
        white-space: nowrap;
        // merge conflict resolution
        //width: 100%;
        //display: block;
        //> span{
        //    overflow: hidden;
        //    width: 100%;
        //    display: block;
        //    text-align: left;
        //}
        color: #47566D;
    }

    .react-dropdown-select-clear,
    .react-dropdown-select-dropdown-handle {
        // merge conflict resolution
        //position: absolute;
        //right: 5px;
        //top: 0;
        //bottom: 0;
        //display: flex;
        //align-items: center;
        //justify-content: center;
        //color: black;
        //width: 30px;
        //padding-bottom: 5px;
        width: 30px;
        color: #47566D;
      
        svg{
            width: 26px;
            height: 26px;
        }
    }
    
    .react-dropdown-select-input{
        font-size: 18px;
        font-weight: 500;
        display: none;
    }
    
    .react-dropdown-select-dropdown {
        position: absolute;
        left: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        max-height: 300px;
        overflow: auto;
        z-index: 9;
        background: #2C4EB5;
        box-shadow: none;
        border: 1px solid #D2D5D7 !important;
        color: black!important;
        border-radius: 16px;

        .react-dropdown-select-item:not(:last-child) {
            border-bottom: 1px solid #D2D5D7;
        }
    }
  
    .react-dropdown-select-item {
        font-size: 18px;
        font-weight: 500;
        padding: 12px 24px;
        background: #F2F0EE;
        color: #47566D;
        
        :hover {
            background: #D2D5D7;
        }
    }
    
    .react-dropdown-select-item-selected{
      background-color: #2C4EB5 !important;
      border-bottom: 1px solid #D2D5D7;
      
      &:hover{
            background-color: #2C4EB5;
        }
    }
`;

export default StyledSelect;
